import Link from '@/components/client/seo/link'
import { tw } from '@/lib/utils'

interface FeaturedProductsHeaderProps {
  title: string
  compareAll: string
  className?: string
}

export const FeaturedProductsHeader = ({ title, compareAll, className }: FeaturedProductsHeaderProps) => (
  <div className={tw('@container/featured-products flex items-center justify-between gap-4', className)}>
    <h3 className="flex min-w-0 items-center gap-2 text-xl leading-none font-bold tracking-tight whitespace-nowrap text-[#142546]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="shrink-0 text-[#4a7fe5]"
        aria-hidden="true"
      >
        <path d="M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2" />
      </svg>
      {title}
    </h3>
    <Link
      href="/hearing-aids/compare"
      prefetch={false}
      data-tracking="ignore"
      className="hidden shrink-0 text-xs font-bold tracking-wide text-[#4a7fe5] uppercase hover:underline @min-[22rem]/featured-products:block"
    >
      {compareAll}
    </Link>
  </div>
)
